import { DynamicObjectInterface } from '@commerce-profile-webcomponents/sdk';
import { InputValidations } from '@nextgen-web-framework/all';

export const inputErrorStatus = (touched?: boolean, error?: string): DynamicObjectInterface =>
  touched && typeof error !== 'undefined' && error ? InputValidations.INVALID : InputValidations.DEFAULT;

export const inputErrorMessage = (
  t: DynamicObjectInterface,
  touched?: boolean,
  error?: string,
  params?: Record<string, string | number>,
) => {
  const stringParams: Record<string, string> = {};
  let message = '';
  const fallbackMsg = t('profile.common.somethingWentWrong');
  // Convert number values to strings in params
  if (params) {
    Object.keys(params).forEach((key) => {
      stringParams[key] = String(params[key]);
    });
  }

  try {
    const translatedMsg = t(`${error}`, stringParams) || fallbackMsg;
    message = translatedMsg === error ? fallbackMsg : translatedMsg;
  } catch {
    message = fallbackMsg;
  }

  return touched && typeof error !== 'undefined' && error ? message : '';
};
